/* Seibertron Japanese product accessibility localization 2026-08-12. */
(function () {
  'use strict';
  if (!/^ja(?:-|$)/i.test(document.documentElement.lang || '')) return;
  var exactText = {
    'View A+ images': 'A+画像を見る',
    'Collapse A+ images': 'A+画像を閉じる'
  };
  function candidates(root, selector) {
    var nodes = [];
    if (root && root.nodeType === 1 && root.matches(selector)) nodes.push(root);
    if (root && root.querySelectorAll) nodes = nodes.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    return nodes;
  }
  function englishOnly(value) {
    return /[A-Za-z]/.test(value || '') && !/[぀-ヿ㐀-鿿]/.test(value || '');
  }
  function productTitle() {
    var node = document.querySelector('.auto-product h1, .auto-product__title, main h1');
    return (node && node.textContent || 'Seibertron商品').trim();
  }
  function localizedProductAlt(source, title, index) {
    if (/size\s*chart|sizing\s*chart|size\s*guide/i.test(source)) return title + 'のサイズ表';
    if (/measurement|measure/i.test(source)) return title + 'の採寸方法';
    if (/touch\s*screen|touchscreen/i.test(source)) return title + 'のタッチスクリーン対応機能 ' + index;
    return title + 'の商品説明画像 ' + index;
  }
  function localizeProductCardRating20260812(root) {
    candidates(root, '.seib-default-card__review').forEach(function (review) {
      var label = (review.getAttribute('aria-label') || '').trim();
      var match = label.match(/^Rated\s+([\d.]+)\s+out of\s+5\s+based on\s+(\d+)\s+reviews?$/i);
      if (match) review.setAttribute('aria-label', '5点満点中' + match[1] + '点（' + match[2] + '件のレビュー）');
      Array.prototype.slice.call(review.querySelectorAll('span')).forEach(function (node) {
        var text = (node.textContent || '').trim();
        var count = text.match(/^(\d+)\s+reviews?$/i);
        if (count) node.textContent = count[1] + '件のレビュー';
      });
    });
  }
  function localizeCollectionSort20260812(root) {
    candidates(root, 'select[aria-label]').forEach(function (select) {
      if ((select.getAttribute('aria-label') || '').trim() === 'Sort products') {
        select.setAttribute('aria-label', '商品を並べ替える');
      }
    });
  }
  function localizeCookiePrivacyLink20260812(root) {
    candidates(root, '#shopify-pc__banner__body-policy-link[href]').forEach(function (link) {
      var href = (link.getAttribute('href') || '').trim();
      try {
        var url = new URL(href, window.location.origin);
        if (url.hostname === 'seibertron-outdoor.com' && /\/(?:ja\/)?policies\/privacy-policy\/?$/.test(url.pathname)) {
          link.setAttribute('href', '/policies/privacy-policy');
        }
      } catch (error) {}
    });
  }
  function localizePrivacyDntHeading20260812(root) {
    var path = (window.location.pathname || '').replace(/\/+$/, '');
    if (path !== '/pages/privacy-policy' && path !== '/policies/privacy-policy') return;
    candidates(root, 'main strong, main h1, main h2, main h3, main h4, main h5, main h6').forEach(function (node) {
      if ((node.textContent || '').replace(/\s+/g, ' ').trim() === 'Do Not Track') {
        node.textContent = '\u30c8\u30e9\u30c3\u30ad\u30f3\u30b0\u62d2\u5426\uff08Do Not Track\uff09';
      }
    });
  }
  function localizeHistoryWidgets20260812(root) {
    var scope = root && root.nodeType ? root : document;
    var nodes = [];
    if (scope.nodeType === 3) nodes.push(scope);
    else if (scope.querySelectorAll) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
    }
    nodes.forEach(function (node) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(node.parentElement.tagName)) return;
      var text = (node.nodeValue || '').replace(/\s+/g, ' ').trim();
      var translated = text === 'Recently Viewed' ? '\u6700\u8fd1\u30c1\u30a7\u30c3\u30af\u3057\u305f\u5546\u54c1' :
        text === 'Purchase History' ? '\u95b2\u89a7\u5c65\u6b74' : '';
      if (!translated) return;
      var leading = (node.nodeValue.match(/^\s*/) || [''])[0];
      var trailing = (node.nodeValue.match(/\s*$/) || [''])[0];
      node.nodeValue = leading + translated + trailing;
    });
  }
  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    localizeHistoryWidgets20260812(scope);
    localizePrivacyDntHeading20260812(scope);
    localizeCookiePrivacyLink20260812(scope);
    localizeCollectionSort20260812(scope);
    localizeProductCardRating20260812(scope);
    candidates(scope, 'button, a, [role="button"]').forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (exactText[text]) node.textContent = exactText[text];
    });
    candidates(scope, 'img[alt]').forEach(function (image) {
      if ((image.getAttribute('alt') || '').trim() === 'User picture') image.setAttribute('alt', 'ユーザー画像');
    });
    var title = productTitle();
    Array.prototype.slice.call(document.querySelectorAll('.auto-product__details img[alt]')).forEach(function (image, index) {
      var alt = (image.getAttribute('alt') || '').trim();
      if (alt === 'User picture' || image.closest('.jdgm-widget, [class*="jdgm-"]')) return;
      if (englishOnly(alt)) image.setAttribute('alt', localizedProductAlt(alt, title, index + 1));
    });
  }
  function start() {
    apply(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.target && record.target.nodeType === 1) apply(record.target);
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) apply(node); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'href'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
